

























import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator';
import ClickOutside from 'vue-click-outside';
import { SearchKeywordData, SearchKeywordInputOption } from '@/pro/types/product';

@Component({
  directives: {
    ClickOutside,
  },
})
export default class SearchKeywordInput extends Vue {
  @PropSync('keyword') private keywordSync!: string;
  @Prop({ required: true }) private options!: SearchKeywordInputOption;
  @Prop({ required: true }) private data!: SearchKeywordData[];
  @Prop({ required: false, default: false }) private readonly disabled!: boolean;

  private NO_RESULT_CODE = -1;
  private filteredBrandsByKeyword: SearchKeywordData[] = [];
  private inputOption: SearchKeywordInputOption = {
    className: '',
    placeholder: this.$t('PLACEHOLDER_SEARCH'),
    disabled: false,
    isDirect: false,
    showSearchBtn: false,
    useResetBtn: false,
    useCount: false,
    useHighlight: true,
    maxLength: 100,
  };
  private noSearchKeyword: SearchKeywordData = {
    selectKey: this.NO_RESULT_CODE,
    selectDisplayName: this.$t('PRO_PRODUCT_ADD_NO_SEARCH_RESULTS'),
  };

  created() {
    Object.assign(this.inputOption, this.options);
  }

  // make filter data
  @Watch('data')
  private filterByKeyword() {
    this.filteredBrandsByKeyword = this.data?.filter(item => {
      return (item.selectDisplayName as string).includes(this.keywordSync);
    });
  }

  // reset filter data
  private resetFilter() {
    this.filteredBrandsByKeyword = [];
  }

  // change main input event
  private onInput(event: InputEvent): void {
    this.keywordSync = (event.target as HTMLInputElement).value;
    this.$nextTick(() => this.searchKeyword('change'));
  }

  // focus main input event
  private onFocus(): void {
    this.searchKeyword('focus');
  }

  private onKeyup(event: InputEvent) {
    this.keywordSync = (event.target as HTMLInputElement).value;
    this.$nextTick(() => this.searchKeyword('debounce'));
  }

  private searchKeyword(emitEvent: string) {
    if (this.keywordSync) {
      this.filterByKeyword();

      if (!this.filteredBrandsByKeyword?.length) {
        this.filteredBrandsByKeyword = [{ ...this.noSearchKeyword }];
      }
    } else {
      this.resetFilter();
    }

    this.$emit(emitEvent);
  }

  // click filter item
  private selectItem(item: SearchKeywordData) {
    if (item.selectKey === this.NO_RESULT_CODE) {
      return;
    }

    this.keywordSync = item.selectDisplayName as string;
    this.resetFilter();

    this.$emit('change');
  }

  // click direct button
  private insertDirect(): void {
    if (!this.keywordSync) {
      return;
    }

    this.$emit('create');
    this.resetFilter();
  }

  // click initialize button
  private initialize(): void {
    this.keywordSync = '';
    this.resetFilter();
  }

  // return html filter item
  private getNameHtml(name: string): string {
    if (!this.inputOption.useHighlight) {
      return name;
    }

    const regExp = new RegExp(this.keywordSync, 'g');
    return name.replace(regExp, `<span>${this.keywordSync}</span>`);
  }
}
